import blog from './blog';
import ecommerceCatalog from './ecommerceCatalog';

export default {
  blog,
  ecommerceCatalog,
};
